import { ShoppingList } from "src/services/favorites/types";
import { LocalizeFunc } from "src/services/localize/useLocalizeService";

const getFavoritesListName = (list: ShoppingList | null, localize: LocalizeFunc) => {
  return list && !list.is_default ? list.name : localize('favorites.default_name');
};

export default getFavoritesListName;
